import { render, staticRenderFns } from "./EditTheft.vue?vue&type=template&id=6cbf4d54"
import script from "./EditTheft.vue?vue&type=script&lang=js"
export * from "./EditTheft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports